import { isNil, isNull, pickBy } from 'lodash';

export function isComponentHidden(
  viewTemplate?: MBAPI.ViewTemplate,
  viewOptions?: MBAPI.ViewTemplate_componentsViewOptions,
  component?: MBAPI.WorkflowTemplate_components,
) {
  const overrideValue = viewOptions?.overrides?.isHidden ?? viewOptions?.isHidden;

  if (!isNil(overrideValue)) {
    return overrideValue;
  }

  return component?.isHidden === true || viewTemplate?.defaultHiddenComponents === true;
}

export function isComponentReadOnlyInView(component, viewTemplate: MBAPI.ViewTemplate) {
  const viewOptions = getComponentViewOptions(component, viewTemplate);
  return isComponentReadOnly(
    component,
    viewOptions?.overrides,
    viewTemplate.defaultReadonlyComponents ?? undefined,
  );
}

export function getComponentViewOptions(component, viewTemplate: MBAPI.ViewTemplate) {
  return viewTemplate?.componentsViewOptions?.find(option => component.id === option.componentId);
}

export function isComponentReadOnly(
  component,
  overrides,
  templateDefaultReadonly?: boolean,
): boolean {
  const overrideReadonly = overrides?.readonly;
  if (!isNil(overrideReadonly)) {
    return overrideReadonly;
  }
  return (
    (!isNil(component.readonly) && component.readonly) ||
    (!isNil(templateDefaultReadonly) && templateDefaultReadonly)
  );
}

// because all props that are *not* overridden are set to null in the view template,
// we have to specifically pick them out to avoid clearing values.
// limiting to a subset of keys used in the UI.
// readonly and isHidden are handled above.
const handledOverrides = ['label', 'placeholder'];

export function getComponentWithOverrides(
  component: MBAPI.WorkflowTemplate_components,
  viewTemplate: MBAPI.ViewTemplate,
): MBAPI.WorkflowTemplate_components {
  const viewOptions = viewTemplate.componentsViewOptions?.find(
    option => component.id === option.componentId,
  );

  if (isNil(viewOptions?.overrides)) {
    return component;
  }

  const overrides: Partial<MBAPI.WorkflowTemplate_components> = pickBy(
    viewOptions.overrides,
    (value, key) => handledOverrides.includes(key) && !isNull(value),
  );

  return {
    ...component,
    ...overrides,
  };
}
